/*
 * Navibreizhshop : bouton "Me prévenir quand le produit est disponible".
 * Affiché à la place du bouton Ajouter sur les produits/variantes indisponibles
 * (stock épuisé et "continuer à vendre" désactivé).
 * La demande est envoyée via le formulaire de contact Shopify : elle arrive
 * dans la boîte mail de contact de la boutique (produit, variante, référence, lien).
 * Chargé sur tout le site (snippets/scripts.liquid) : les clics sont gérés par
 * délégation sur le document, ce qui fonctionne aussi pour les grilles rechargées
 * en AJAX (filtres, pagination, recherche).
 */

const NBZ_STYLE_ID = 'nbz-notify-style';
const NBZ_CSS = `
nbz-notify-me{display:block;width:100%;flex:1 1 auto;min-width:0}
nbz-notify-me .button{width:100%}
nbz-notify-me .button__content{white-space:normal;text-align:center;line-height:1.2}
dialog.nbz-notify-dialog{position:fixed !important;inset:0 !important;margin:auto !important;width:min(440px,calc(100vw - 32px)) !important;max-width:100% !important;height:fit-content !important;max-height:calc(100vh - 32px) !important;overflow:auto;padding:0 !important;border:none;border-radius:var(--card-border-radius,12px);background:var(--color-background,#fff);color:var(--color-foreground,#111);box-shadow:0 20px 60px rgba(0,0,0,.25);z-index:1000}
dialog.nbz-notify-dialog:not([open]){display:none !important}
dialog.nbz-notify-dialog::backdrop{background:rgba(0,0,0,.5) !important;backdrop-filter:none}
.nbz-notify-dialog__body{position:relative;padding:28px 24px 24px;display:flex;flex-direction:column;gap:12px}
.nbz-notify-dialog__close{position:absolute;top:8px;right:8px;width:36px;height:36px;border:none;background:none;font-size:26px;line-height:1;cursor:pointer;color:inherit}
.nbz-notify-dialog p{margin:0}
.nbz-notify-dialog__title{font-size:1.2em;font-weight:600;padding-right:28px}
.nbz-notify-dialog__product{font-weight:600}
.nbz-notify-dialog form{display:flex;flex-direction:column;gap:10px}
.nbz-notify-dialog form[hidden]{display:none}
.nbz-notify-dialog input[type=email]{width:100%;box-sizing:border-box;min-height:var(--inputs-min-height,46px);padding:0 14px;border:1px solid var(--color-border,#ccc);border-radius:var(--inputs-border-radius,8px);font:inherit;background:#fff;color:#111}
.nbz-notify-dialog__legal{font-size:.8em;opacity:.75}
.nbz-notify-dialog__message{font-weight:500}
.nbz-notify-dialog__message--error{color:#c0392b}
.nbz-notify-dialog__message--success{color:#1e8e3e}
`;

let nbzDialog = null;
let nbzLastEmail = '';

function nbzEnsureStyle() {
  if (document.getElementById(NBZ_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = NBZ_STYLE_ID;
  style.textContent = NBZ_CSS;
  document.head.appendChild(style);
}

function nbzGetDialog() {
  if (nbzDialog) return nbzDialog;
  nbzEnsureStyle();

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const dialog = document.createElement('dialog');
  dialog.className = 'nbz-notify-dialog color-scheme-1';
  dialog.setAttribute('aria-labelledby', 'nbz-notify-title');
  dialog.innerHTML = `
    <div class="nbz-notify-dialog__body">
      <button type="button" class="nbz-notify-dialog__close" aria-label="Fermer" data-nbz-close>&times;</button>
      <p class="nbz-notify-dialog__title" id="nbz-notify-title">Être prévenu de la disponibilité</p>
      <p class="nbz-notify-dialog__product" data-nbz-product></p>
      <form method="post" action="${root}contact" accept-charset="UTF-8" data-nbz-form>
        <input type="hidden" name="form_type" value="contact">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="contact[Demande]" value="Me prévenir quand le produit est disponible">
        <input type="hidden" name="contact[Produit]" data-nbz-field="product">
        <input type="hidden" name="contact[Variante]" data-nbz-field="variant">
        <input type="hidden" name="contact[Référence]" data-nbz-field="sku">
        <input type="hidden" name="contact[Lien]" data-nbz-field="url">
        <input type="hidden" name="contact[body]" data-nbz-field="body">
        <p>Laissez votre adresse e-mail : nous vous écrirons dès que cet article sera de nouveau disponible.</p>
        <input type="email" name="contact[email]" required autocomplete="email" placeholder="Votre adresse e-mail" aria-label="Adresse e-mail">
        <button type="submit" class="button button--primary button--full-width" data-nbz-submit>Me prévenir</button>
        <p class="nbz-notify-dialog__legal">Votre adresse sert uniquement à vous informer de la disponibilité de ce produit.</p>
      </form>
      <p class="nbz-notify-dialog__message" data-nbz-message hidden></p>
    </div>
  `;
  document.body.appendChild(dialog);

  const form = dialog.querySelector('[data-nbz-form]');
  const submit = dialog.querySelector('[data-nbz-submit]');
  const message = dialog.querySelector('[data-nbz-message]');
  const email = form.querySelector('input[type="email"]');

  const showMessage = (type, text) => {
    message.hidden = false;
    message.className = `nbz-notify-dialog__message nbz-notify-dialog__message--${type}`;
    message.textContent = text;
  };
  const showSuccess = () => {
    form.hidden = true;
    showMessage('success', 'Merci ! Nous vous préviendrons par e-mail dès que ce produit sera de nouveau disponible.');
  };
  const showError = () => {
    showMessage('error', "L'envoi n'a pas fonctionné. Vérifiez votre adresse e-mail et réessayez, ou appelez-nous au 02 59 16 35 80.");
  };

  dialog.querySelector('[data-nbz-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!email.checkValidity()) {
      email.reportValidity();
      return;
    }
    nbzLastEmail = email.value.trim();
    submit.disabled = true;
    submit.textContent = 'Envoi…';
    message.hidden = true;

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
      });

      // Protection anti-robots Shopify : on bascule sur un envoi classique (page de vérification).
      if (response.url && response.url.includes('/challenge')) {
        HTMLFormElement.prototype.submit.call(form);
        return;
      }

      // Seul un refus explicite du formulaire (adresse invalide, champ manquant) est une erreur.
      // Shopify répond par une redirection après avoir enregistré le message : la page d'arrivée
      // peut renvoyer un statut quelconque sans que l'envoi ait échoué.
      if (response.status === 400 || response.status === 422) {
        console.warn('nbz-notify-me : formulaire refusé', response.status);
        showError();
      } else {
        showSuccess();
      }
    } catch (error) {
      // Une erreur réseau survient aussi quand la redirection de Shopify part vers un autre domaine,
      // alors que le message est bien enregistré. On ne signale une erreur que si l'appareil est hors ligne.
      console.warn('nbz-notify-me', error);
      if (navigator.onLine === false) {
        showError();
      } else {
        showSuccess();
      }
    } finally {
      submit.disabled = false;
      submit.textContent = 'Me prévenir';
    }
  });

  nbzDialog = dialog;
  return dialog;
}

function nbzOpen(data) {
  const dialog = nbzGetDialog();
  const form = dialog.querySelector('[data-nbz-form]');
  const message = dialog.querySelector('[data-nbz-message]');
  const product = data.productTitle || '';
  const variant = data.variantTitle || '';
  const url = new URL(data.url || window.location.pathname, window.location.origin).href;

  form.reset();
  form.hidden = false;
  message.hidden = true;

  const set = (key, value) => {
    const input = form.querySelector(`[data-nbz-field="${key}"]`);
    if (input) input.value = value;
  };
  set('product', product);
  set('variant', variant || '—');
  set('sku', data.sku || '—');
  set('url', url);
  set('body', `Merci de me prévenir quand ce produit est de nouveau disponible : ${product}${variant ? ` (${variant})` : ''}`);

  const email = form.querySelector('input[type="email"]');
  if (nbzLastEmail) email.value = nbzLastEmail;

  dialog.querySelector('[data-nbz-product]').textContent = variant ? `${product} – ${variant}` : product;

  if (typeof dialog.showModal === 'function') {
    if (!dialog.open) dialog.showModal();
  } else {
    dialog.setAttribute('open', '');
  }
  setTimeout(() => email.focus(), 50);
}

if (!customElements.get('nbz-notify-me')) {
  customElements.define('nbz-notify-me', class extends HTMLElement {});
}

// Délégation globale (phase de capture) : fonctionne pour tous les boutons, y compris ceux
// insérés plus tard en AJAX, et passe avant les gestionnaires de clic des cartes produit.
if (!window.__nbzNotifyBound) {
  window.__nbzNotifyBound = true;
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('nbz-notify-me button');
      if (!button) return;
      const host = button.closest('nbz-notify-me');
      event.preventDefault();
      event.stopPropagation();
      nbzOpen(host.dataset);
    },
    true,
  );
}
